var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[(_vm.loaded)?[_vm._v("更多内容请登录在艺App查看~")]:(_vm.loading)?[_c('img',{attrs:{"src":require("../../../assets/img/icon/loading.gif")}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }